<template>
    <v-container>
        <ModuleBar title="ADMINISTRAR EMPLEADOS" />

        <v-row v-if="loadingSearch">
            <v-col class=" mt-10 d-flex justify-center">
                <v-progress-circular indeterminate size="60" width="2" color="primary" />
            </v-col>
        </v-row>

        <v-card outlined class="mt-10" v-if="employees">
            <v-card-text>
                <v-list>
                    <v-list-item-group color="primary">
                        <template v-for="employee, key in employees">
                            <v-list-item :key="key" v-if="employees" @click="openDialogEmployee(employee, 'edit')">
                                <v-list-item-avatar>
                                    <v-img :src="employee.photo_url" :lazy-src="employee.photo_thumb_url" />
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title>{{ employee.names }} {{ employee.last_names
                                        }}</v-list-item-title>
                                    <v-list-item-subtitle>{{ employee.avatar }}</v-list-item-subtitle>
                                    <v-list-item-subtitle v-if="employee.category">
                                        {{
                                            employee.category ? employee.category.name : ''
                                        }}
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle>INGRESO: {{ employee.admission_date }}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider :key="`key${key}`" v-if="key != employees.length - 1" />
                        </template>
                    </v-list-item-group>
                </v-list>
            </v-card-text>
        </v-card>

        <v-dialog width="1000" v-model="dialogEmployee" persistent>
            <v-card>
                <v-card-title>Datos del empleado</v-card-title>
                <v-card-text>
                    <employee-form :employee="employee" schema="edit" @closeDialogEmployee="closeDialogEmployee" />
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import ModuleBar from '../../components/General/ModuleBar.vue';
import EmployeeForm from "../../components/Forms/employeeForm.vue";

export default {
    props: ['type', 'click'],

    components: { ModuleBar, EmployeeForm },

    beforeMount() {
        this.search();
    },

    data() {
        return {
            dialogEmployee: false,
            isSearch: false,
            loadingSearch: false,
            params: "",
            employees: null,
            employee: null,
        };
    },

    watch: {
        click() {
            this.search();
        }
    },

    methods: {
        search() {
            this.employees = null;
            this.loadingSearch = true;
            this.isSearch = true;

            let payload = {
                params: this.type
            }

            setTimeout(() => {
                this.$store.dispatch("searchEmployeeAction", payload).then((res) => {
                    this.employees = res;
                    this.loadingSearch = false;
                    this.isSearch = false;
                }).catch(() => {
                    this.loadingSearch = false;
                    this.isSearch = false;
                })
            }, 500);
        },

        openDialogEmployee(employee, schema) {
            this.schema = schema;
            this.dialogEmployee = true;
            this.employee = employee;
        },

        closeDialogEmployee(payload) {
            this.dialogEmployee = false;
            this.employee = null;

            if (payload.action == 'delete') {
                let index = this.employees.findIndex((x) => x.id == payload.employeeId);
                if (index >= 0) {
                    this.employees.splice(index, 1)
                    if (this.employees.length == 0) {
                        this.employees = null;
                    }
                }
            }
            else if (payload.action == "edit") {
                let index = this.employees.findIndex((x) => x.id == payload.employeeId);
                if (index >= 0) {
                    this.employees[index].names = payload.employee.names;
                    this.employees[index].last_names = payload.employee.last_names;
                    this.employees[index].avatar = payload.employee.avatar;
                    this.employees[index].admission_date = payload.employee.admission_date;
                    this.employees[index].responsibility = payload.employee.responsibility;
                    this.employees[index].recommended = payload.employee.recommended;
                    this.employees[index].photo_url = payload.employee.photo_url;
                    this.employees[index].category = payload.employee.category;
                    this.employees[index].district = payload.employee.district;
                }
            }
        }
    },
}
</script>